import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function GuestUserRoutes({ component: Component, ...rest }) {
  const authenticated =
    localStorage.getItem("access_token") || localStorage.getItem("user_key");
  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? <Component {...props} /> : <Redirect push to="/login" />
      }
    />
  );
}
